/* eslint-disable @typescript-eslint/no-unsafe-member-access -- Start: // TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */
import { endOfDay, isBefore } from 'date-fns';
import { useCallback } from 'react';
import type { SessionStorageGivingItem } from '../useGiveNowSessionStorage';

export const useValidatedGives = () =>
  useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    (giving: any[]): SessionStorageGivingItem[] =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      giving.filter((give) => {
        if (
          typeof give !== 'object' ||
          give === null ||
          typeof give.amount !== 'number' ||
          typeof give.id !== 'string' ||
          typeof give.priceId !== 'string' ||
          typeof give.name !== 'string' ||
          typeof give.type !== 'string' ||
          typeof give.showCustomAmount !== 'boolean'
        ) {
          return false;
        }

        return !(
          give.endTime &&
          // eslint-disable-next-line  @typescript-eslint/no-unsafe-argument -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          (typeof give.endTime !== 'string' || isBefore(new Date(give.endTime), endOfDay(new Date())))
        );
      }),
    [],
  );
/* eslint-enable @typescript-eslint/no-unsafe-member-access -- End: TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare case */
